import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { 
    content: String 
  }
  static targets = ["button", "defaultIcon", "successIcon"]

  copy(event) {
    event.preventDefault()

    if (!this.contentValue) return

    navigator.clipboard.writeText(this.contentValue).then(() => {
      this.showSuccess()
    })
  }

  showSuccess() {
    // Toggle icons to give visual feedback
    this.defaultIconTarget.classList.add("hidden")
    this.successIconTarget.classList.remove("hidden")
    this.buttonTarget.classList.add("text-green-500")
    this.buttonTarget.classList.remove("text-gray-400")

    // Revert after 2 seconds
    setTimeout(() => {
      this.defaultIconTarget.classList.remove("hidden")
      this.successIconTarget.classList.add("hidden")
      this.buttonTarget.classList.remove("text-green-500")
      this.buttonTarget.classList.add("text-gray-400")
    }, 2000)
  }
}